import { render, staticRenderFns } from "./research.vue?vue&type=template&id=58fd691d&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"
import style0 from "./research.vue?vue&type=style&index=0&id=58fd691d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd691d",
  null
  
)

export default component.exports